import { render } from "./AddStockIn.vue?vue&type=template&id=5db0a3ef&scoped=true&ts=true"
import script from "./AddStockIn.vue?vue&type=script&lang=ts"
export * from "./AddStockIn.vue?vue&type=script&lang=ts"

import "./AddStockIn.vue?vue&type=style&index=0&id=5db0a3ef&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db0a3ef"]])

export default __exports__